import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import Search from "app/components/search";
import Navigator from "app/components/navigator";
import Map from "app/components/map";
import Loader from "app/components/loader";

import digiPadalaLogo from "app/assets/DigiPadala.png";
import "./App.scss";
import "fontsource-poppins/latin.css";
import "fontsource-exo-2/latin.css";
import { loadScript } from "app/components/utils";
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const GOOGLE_MAPS_API_URL = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places,visualization&v=3.42`;

const App = () => {
  const [sessionToken, setSessionToken] = useState(null);
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  useEffect(() => {
    loadScript(GOOGLE_MAPS_API_URL, function test() {
      setIsScriptLoaded(true);
      setSessionToken(window.google.maps.places.AutocompleteSessionToken());
    });
  }, []);

  const { lookingUp, filtering } = useSelector((state) => state.branchesData);
  useEffect(() => {
    onBranchClick(null);
  }, [lookingUp, filtering]);

  const [selectedBranch, setSelectedBranch] = useState(null);

  const onBranchClick = (branch) => setSelectedBranch(branch);

  return (
    <BrowserRouter basename="/">
      <Switch>
        <Redirect exact from="/" to="/branch-locator" />
        <Route exact path="/branch-locator">
          {isScriptLoaded ? (
            <div className="branch-locator">
              <header className="branch-locator__header">
                <span>
                  <img src={digiPadalaLogo} alt="digipadala-logo" />
                </span>
                <h4 className="branch-locator__subtitle">BRANCH LOCATOR</h4>
                <Search sessionToken={sessionToken} />
              </header>
              <div className="branch-locator__map-wrapper">
                {lookingUp || filtering ? (
                  <div className="branch-locator__map">
                    <Loader />
                  </div>
                ) : (
                  <div className="branch-locator__map">
                    <Navigator onBranchClick={onBranchClick} />
                    <Map selectedBranch={selectedBranch} />
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="branch-locator">
              <Loader />
            </div>
          )}
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

export default App;
